import React, { Component } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";

export default function VehicleCategoryModal({
    show, 
    currentCategory, 
    currentFbDimension, 
    currentBbDimension, 
    currentValue, 
    onClose, 
    onCategoryChange,
    onFbDimensionChange,
    onBbDimensionChange,
    onSave,
    onUpdate,}){
 
    return (
      <div
        className={`modal fade ${show ? "show" : "hide"}`}
        style={{ display: show ? "block" : "none" }}
        id="modal-sm"
        aria-modal="true"
        role="dialog"
      >
        <div className="modal-dialog modal-sm">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Vehicle Category</h4>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true" onClick={() => onClose()}>
                  ×
                </span>
              </button>
            </div>
            <div className="modal-body">
              <div className="col-sm-12">
                <div className="form-group">
                  <label>Type</label>
                  <input
                    type="text"
                    name="text"
                    className="form-control"
                    id="vehicleType"
                    onChange={(e) => onCategoryChange(e.target.value)}
                    placeholder="Vehicle Type"
                    defaultValue={currentValue ? currentCategory : ""}
                  />
                </div>
              </div>
            </div>

            <div className="modal-body">
              <div className="col-sm-12">
                <div className="form-group">
                  <label>Frontboard Dimension</label>
                  <input
                    type="text"
                    name="text"
                    className="form-control"
                    id="fbDimension"
                    onChange={(e) => onFbDimensionChange(e.target.value)}
                    placeholder="Vehicle Type"
                    defaultValue={currentValue ? currentFbDimension : ""}
                  />
                </div>
              </div>
            </div>

            <div className="modal-body">
              <div className="col-sm-12">
                <div className="form-group">
                  <label>Backboard Dimension</label>
                  <input
                    type="text"
                    name="text"
                    className="form-control"
                    id="bbDimension"
                    onChange={(e) => onBbDimensionChange(e.target.value)}
                    placeholder="Vehicle Type"
                    defaultValue={currentValue ? currentBbDimension : ""}
                  />
                </div>
              </div>
            </div>

            <div className="modal-footer justify-content-between">
              <button
                type="button"
                className="btn btn-default"
                data-dismiss="modal"
                onClick={() => onClose()}
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => (currentValue ? onUpdate() : onSave())}
              >
                Save changes
              </button>
            </div>
          </div>
          {/* /.modal-content */}
        </div>
        {/* /.modal-dialog */}
      </div>
    );
 
}
